import FileSaver from 'file-saver';

export const downloadFile = async (url: string, fileName: string, throwError?: boolean) => {
  const response = await fetch(url);

  if (!response.ok) {
    if (throwError) {
      throw new Error(response.statusText);
    }

    return;
  }

  const fileBlob = await response.blob();

  FileSaver.saveAs(fileBlob, fileName);
};
